<template >

    <div class="login-bg">
    <w-app id="app" class="justify-space-between basis-zero justify-center align-center login-bg">
      <w-notification
          v-if="$page.props.flash.success"
          success
          transition="bounce"
          absolute
          plain
          round
          timeout="4000"
          @close="$page.props.flash.success = ''"
      >
          {{ $page.props.flash.success }}
      </w-notification>

      <w-notification
          v-if="$page.props.message"
          error
          transition="bounce"
          absolute
          plain
          round
          timeout="2000"
          @close="$page.props.flash.notifyerror = ''"
      >
          {{ $page.props.message }}
      </w-notification>
      <header></header>
      

      <main class="grow align-self-center mt10" >

        <w-card class="zloginbox-title">

          <!--
          <w-image
            class="zloginbox"
            src="/images/jata-malaysia.svg"
            height="250"
            width="100%"
          ></w-image>
          -->

          <div class="zloginbox-logo">
              <img src="/images/logog.png">
          </div>

          <div class="zloginbox-title-top">Log Masuk ke Sistem</div>
          <!-- <div class="zloginbox-title-bottom">Log Masuk ke Sistem Recon-VMS</div> -->

        </w-card>

        <w-card class="zloginbox">
          <w-alert
              class="my0 mb2 text-light"
              v-if="$page.props.message"
              error
              transition="bounce"
              plain
              round
              no-border
              dismiss
          >
              {{ $page.props.message }}
          </w-alert>

        <template #buttons />

          <w-form
            @validate="attemp"
          >
            <z-input
              outline
              label="ID Pengguna "
              placeholder="Sila Masukkan ID Pengguna "
              name="no_id"
              v-model="form.no_id"
              :validators="[validators.required]"
            />
            <div class="spacer"></div>
            <z-input
              outline
              label="Kata laluan"
              class="mt5"
              placeholder="Sila Masukkan Kata Laluan"
              type="password"
              name="password"
              v-model="form.password"
              :validators="[validators.required]"
            />

              <div class="mt5 mb5"></div>

              <w-flex justify-center align-end>
                  <div class="xs6">
                      <!-- <w-checkbox>Ingat Saya</w-checkbox> -->
                  </div>
                  <div class="xs6 text-right">
                    <inertia-link :href='$route("lupa-katalaluan")'>
                        <w-icon>fal fa-question-circle</w-icon> Lupa kata laluan?
                    </inertia-link>
                  </div>
               </w-flex>

              <w-flex justify-center align-center class="mt5">
                <w-button
                  class="my2 btn-zloginbox grow"
                  type="submit"
                >
                  <w-icon class="mr2" xs>fal fa-sign-in-alt</w-icon> Log Masuk
                </w-button>

              </w-flex>
              <w-flex justify-center align-center class="mt5">
                <inertia-link :href='$route("register")'>
                   <template #activator="{ on }">
                     <w-icon v-on="on" >
                       fal fa-file
                     </w-icon>
                   </template>
                   <w-icon class="mr2" xs>fal fa-user-plus</w-icon> Daftar
                </inertia-link>
              </w-flex>
          </w-form>
        </w-card>

        <div class="zloginbox-title-footer">
              <!-- © 2022 <b>2en Apps Sdn Bhd</b><br>
              Hak Cipta Terpelihara -->
        </div>





      </main>

      <footer>
      </footer>
    </w-app>

  </div>
</template>


<script>
export default {
  data() {
    return {
      form: {
        no_id: '',
        password: ''
      },
      validators: {
          required: value => !!value || 'Medan Ini Wajib'
          // Other validators...
        }
    }
  },
  methods: {
    attemp() {
      this.$inertia.post('login',this.form, {
                preserveState: true,
            })
    }
  }
}
</script>

<style>
#app {
  flex-direction: column;
}
.w-app {
    background: url(/images/aiibg.png);
    background-size: cover !important;
    background-repeat: no-repeat !important;
}
.zloginbox {
  width: 420px;
  background: inherit !important;
}
.zloginbox .w-card__content {
    background: #fff;
}
.zloginbox .w-toolbar {
    background-color: #0c213ab8;
    color: #fff;
}
.zloginbox .w-input__input-wrap {
   font-size: 15px;
    margin-top: 25px;
}
.zloginbox .w-input__label--inside {
    font-size: 15px;
    margin-top: -5px;
    margin-left: -5px;
}
.zloginbox .w-input__input-wrap--box {
    font-size: 15px;
    height: 33px;
}
.zloginbox .w-card__content {
    padding: 16px;
    border-bottom-left-radius: 7px;
    border-bottom-right-radius: 7px;
}
.w-card.zloginbox-title {
    background: #0c213ab8;
    color: #fff;
    text-align: center;
    background: #7e90a4b8;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
    border-top: 1px solid #7e90a4b8;
    border-left: 1px solid #7e90a4b8;
    border-right: 1px solid #7e90a4b8;
    margin-top: 150px;
}
.zloginbox-title-top{
    font-weight: bold;
    font-size: 20px;
    text-shadow: 1px 1px black;
}
.zloginbox-title-bottom {
    margin-bottom: 10px;
    margin-top: 5px;
}
.zloginbox-logo img {
    height: 100px;
    margin-top: 20px;
    margin-bottom: 20px;
}
.btn-zloginbox{
    color: #fff;
    background-color: #1761fd !important;
    border-color: #1761fd !important;
    font-size: 15px !important;
    padding: 15px;
}
.zloginbox-title-footer {
    text-align: center;
    font-size: 13px;
    color: #fff;
    margin-top: 10px;
    text-shadow: 1px 1px black;
}
.w-input__input {
    background: #fff !important;
}
</style>
